import { Link, useLocation } from "react-router-dom";
import { BrandLogo } from "./BrandLogo";

const SHOW_PREFIXES = ["/t/", "/locale/", "/pay/", "/order/"];

export function GlobalHomeLogo() {
  const { pathname } = useLocation();
  if (!SHOW_PREFIXES.some((p) => pathname.startsWith(p))) return null;
  return (
    <Link
      to="/"
      data-testid="global-home-logo"
      title="Torna alla home Pickfood"
      className="fixed top-3 left-3 z-[60] rounded-full bg-white/95 backdrop-blur shadow-lg px-2.5 py-1 hover:scale-105 transition-transform no-print"
    >
      <BrandLogo name="Pickfood" size={30} />
    </Link>
  );
}
